import {Layout} from "../../../src/ts/layouts/Layout";

export class FAQ extends Layout {

    private readonly SELECTOR_TOGGLE_BUTTON: string = ".faq__faqs-question";
    private readonly SELECTOR_TOGGLE_ITEM: string = ".faq__faqs-item";
    private readonly SELECTOR_TOGGLE_CONTENT: string = ".faq__faqs-answer";
    private readonly STATE_ITEM_OPEN: string = "open";

    constructor($elem: JQuery) {
        super($elem);

        this.$layout.find(this.SELECTOR_TOGGLE_BUTTON).on('click', (e) => this.onToggleClick(e));
    }

    private onToggleClick(event: JQuery.ClickEvent) {
        const $target = $(event.target);
        const $item = $target.parents(this.SELECTOR_TOGGLE_ITEM);

        if ($item.hasClass(this.STATE_ITEM_OPEN)) {
            this.$layout.find(this.SELECTOR_TOGGLE_CONTENT).slideUp('200', function () {
            });
            $item.removeClass(this.STATE_ITEM_OPEN);

            return;
        }
        this.$layout.find(this.SELECTOR_TOGGLE_ITEM).removeClass(this.STATE_ITEM_OPEN);

        this.$layout.find(this.SELECTOR_TOGGLE_CONTENT).slideUp('200', function () {
        });
        $item.addClass(this.STATE_ITEM_OPEN);

        // console.log($item.next());

        $target.next().stop().slideDown('300', function () {
            }
        );


    }

}

